// 详情页面对应去展示列表的active
let obj = {
    '/homePage/memberList': [
        /\/detail\/[0-9]*\/.*/,
    ]
};
export const menuDetails = (url) => {
    let resUrl = url;
    for (let key in obj) {
        obj[key].forEach(item => {
            // 动态地址 | 正则的判断
            // /detail/:id/:user
            if (item instanceof RegExp) {
                if (new RegExp(item).exec(url)) resUrl = key;
            } else if (item === url) { // 静态地址
                resUrl = key;
            }
        });
    }
    return resUrl;
};